// 메신저 오피스 미리보기 — MM 미리보기 창 동작 줄에서 «지금 보는 첨부»를 읽는다(순수 함수).
// 설계: `patch_mm_office_preview_p2_frontend.md` §3-2 (우산 `design_mm_office_preview.md`).
//
// 🔴 동작 줄(div.file-preview-modal-main-actions__actions) 안 다운로드 a 의 href 에서 26자 파일 id 를,
//    download 속성에서 파일명을 읽는다. href 는 출처가 붙은 절대 URL 이라(§8-1 실측) `^` 없이 부분 일치로 찾는다.
// 🔴 하나라도 못 읽으면 null — 버튼을 안 넣을 뿐 MM 미리보기는 그대로 쓴다.
export const OFFICE_EXTS = ['docx', 'xlsx', 'pptx'];
export const MAX_PREVIEW_BYTES = 20 * 1024 * 1024;   // 백엔드 P1 MAX_INPUT 과 같은 값
export const OFFICE_LINK_SEL = 'a[download][href*="/api/v4/files/"]';
const FILE_ID_RE = /\/api\/v4\/files\/([a-z0-9]{26})(?:[/?#]|$)/;

// 사용자에게 보이는 문구 — 모달(components/OfficePreviewModal)도 같은 값을 쓴다.
export const OFFICE_MESSAGES = {
  too_large: '파일이 커서 미리보기를 할 수 없습니다',
  unsupported: '이 형식은 미리보기를 지원하지 않습니다',
  // 타임아웃형 실패 뒤 75초 동안도 이 코드가 온다(services/office_preview.py) — «다른 미리보기» 라고 쓰지 않는다.
  in_progress: '미리보기를 만드는 중입니다 — 1~2분 뒤 다시 시도해 주세요',
  busy: '잠시 후 다시 시도해 주세요',
  failed: '미리보기를 만들지 못했습니다',
};

// 동작 줄 → { fileId, fileName, ext } | null. docx·xlsx·pptx 만 돌려준다.
export function readOfficeAttachment(actionsEl) {
  try {
    if (!actionsEl || typeof actionsEl.querySelector !== 'function') return null;
    const a = actionsEl.querySelector(OFFICE_LINK_SEL);
    if (!a) return null;
    const m = FILE_ID_RE.exec(a.getAttribute('href') || '');
    if (!m) return null;
    const fileName = a.getAttribute('download') || '';
    if (!fileName) return null;
    const dot = fileName.lastIndexOf('.');
    if (dot < 0) return null;
    const ext = fileName.slice(dot + 1).toLowerCase();
    if (OFFICE_EXTS.indexOf(ext) < 0) return null;
    return { fileId: m[1], fileName, ext };
  } catch (e) {
    return null;
  }
}

// 실패 문구 — 응답 code 가 먼저, 없으면(nginx 429·413 · FastAPI 검증 422 등) 상태 코드로 고른다.
export function officeErrorMessage(status, code) {
  if (typeof code === 'string' && Object.prototype.hasOwnProperty.call(OFFICE_MESSAGES, code)) {
    return OFFICE_MESSAGES[code];
  }
  if (status === 413) return OFFICE_MESSAGES.too_large;
  if (status === 429) return OFFICE_MESSAGES.busy;
  return OFFICE_MESSAGES.failed;
}
